import { useState } from 'react';
import { AiReviewCell } from '@/components/AiReviewCell';
import { AiReviewDialog } from '@/components/AiReviewDialog';
import { BillVersion, Bill } from '@/types/bill';

interface PrintAIReviewButtonProps {
  latestVersion: BillVersion;
  bill: Bill;
  loadingAction?: string;
}

export function PrintAIReviewButton({ latestVersion, bill, loadingAction }: PrintAIReviewButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <AiReviewCell
        bill={bill}
        latestVersion={latestVersion}
        loadingAction={loadingAction}
        onClick={handleOpenDialog}
      />

      <AiReviewDialog
        bill={bill}
        latestVersion={latestVersion}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}
// import { useState, useMemo } from 'react';
// import { AiReviewCell } from '@/components/AiReviewCell';
// import { AiReviewDialog } from '@/components/AiReviewDialog';
// import { BillVersion } from '@/types/bill';
//
// interface PrintAIReviewButtonProps {
//   latestVersion: BillVersion;
//   billNumber: string;
//   sessionCode: string;
//   loadingAction?: string;
// }
//
// export function PrintAIReviewButton({ latestVersion, billNumber, sessionCode, loadingAction }: PrintAIReviewButtonProps) {
//   const [dialogOpen, setDialogOpen] = useState(false);
//
//   // Create a bill object with the minimum required props for the dialog
//   const billForDialog = useMemo(() => {
//     return {
//       billNumber,
//       session_code: sessionCode,
//     };
//   }, [billNumber, sessionCode]);
//
//   const handleOpenDialog = () => {
//     setDialogOpen(true);
//   };
//
//   return (
//     <>
//       <AiReviewCell
//         bill={billForDialog}
//         latestVersion={latestVersion}
//         loadingAction={loadingAction}
//         onClick={handleOpenDialog}
//       />
//
//       <AiReviewDialog
//         bill={billForDialog}
//         latestVersion={latestVersion}
//         open={dialogOpen}
//         onOpenChange={setDialogOpen}
//       />
//     </>
//   );
// }